import { Component, computed, input, Signal } from "@angular/core";
import { HealthThreshold, MarginHealthIndicator } from "@gql/offer";
import { CoreModule } from "@modules/core/core.module";

@Component({
	selector: "position-line-indicator",
	imports: [CoreModule],
	templateUrl: "./mt-line-indicator.component.html",
	styleUrl: "./mt-line-indicator.component.scss"
})
export class PositionLineIndicatorComponent {
	healthIndicator = input<MarginHealthIndicator>(null);
	marginLevel = input<number>(0);
	marginMinimum = input<number>(0);
	marginMaximum = input<number>(0);
	healthThreshold = input<HealthThreshold>(null);
	indicator = MarginHealthIndicator;

	percentage$: Signal<number> = computed(() => {
		const highToMediumRiskThreshold = +this.healthThreshold()?.low || 1.1;
		const mediumToLowRiskThreshold = +this.healthThreshold()?.high || 1.5;

		let segmentMin: number, segmentMax: number, offset: number;

		switch (this.healthIndicator()) {
			case MarginHealthIndicator.Low:
				{
					segmentMin = this.marginMinimum();
					segmentMax = highToMediumRiskThreshold;
					offset = 0;
				}
				break;
			case MarginHealthIndicator.Medium:
				{
					segmentMin = highToMediumRiskThreshold;
					segmentMax = mediumToLowRiskThreshold;
					offset = 1 / 3;
				}
				break;
			case MarginHealthIndicator.High:
				{
					segmentMin = mediumToLowRiskThreshold;
					segmentMax = this.marginMaximum();
					offset = 2 / 3;
				}
				break;
			default:
				break;
		}

		const clampedMargin = Math.min(Math.max(this.marginLevel(), segmentMin), segmentMax);
		const segmentRange = Math.max(segmentMax - segmentMin, Number.MIN_VALUE);
		const localProgress = (clampedMargin - segmentMin) / segmentRange;
		const totalProgress = offset + localProgress * (1 / 3);
		return Math.min(Math.max(totalProgress, 0), 1) * 100 || 0;
	});
}
